(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["celeste-swatch-expander"] && !Shopify.designMode) return;
  try {
    
(function () {
  function getMax() {
    var cfg = document.querySelector('.clx-swatch-expander-config');
    var m = cfg ? parseInt(cfg.getAttribute('data-max-visible'), 10) : 8;
    return (isNaN(m) || m < 1) ? 8 : m;
  }
  function init(grid) {
    if (grid.getAttribute('data-clx-exp')) { return; }
    var MAX = getMax();
    var swatches = Array.prototype.slice.call(grid.querySelectorAll('.pdp-color-swatch'));
    if (swatches.length <= MAX) { return; }
    grid.setAttribute('data-clx-exp', '1');
    var selected = grid.querySelector('.pdp-color-swatch.is-selected, .pdp-color-swatch.active');
    var hiddenCount = 0;
    swatches.forEach(function (s, i) {
      if (i >= MAX && s !== selected) { s.classList.add('clx-sw-hidden'); hiddenCount++; }
    });
    if (hiddenCount === 0) { grid.removeAttribute('data-clx-exp'); return; }
    grid.classList.add('clx-sw-collapsed');
    var moreLabel = '+ ' + hiddenCount + ' more color' + (hiddenCount === 1 ? '' : 's');
    var lessLabel = 'Show fewer colors';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'clx-swatch-toggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = moreLabel;
    btn.addEventListener('click', function () {
      var collapsed = grid.classList.toggle('clx-sw-collapsed');
      btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      btn.textContent = collapsed ? moreLabel : lessLabel;
    });
    grid.parentNode.insertBefore(btn, grid.nextSibling);
  }
  function run() {
    Array.prototype.forEach.call(document.querySelectorAll('.pdp-color-swatch-grid'), init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  setTimeout(run, 1200);
})();

/* Mobile gallery fallback (see the matching CSS above).
   Detects a PDP image grid that renders NO visible media on mobile (the carousel that
   sets `.cl-active` didn't run for this product) and re-enables the theme's native swipe
   layout so the product images appear. Only ever ADDS the class, and only when the grid
   is genuinely empty — a working carousel keeps its own single-image slider. */
(function () {
  var THRESH = 10; // px: a rendered media item is ~568px tall; a hidden one is 0
  function anyMediaShown(grid) {
    var items = grid.querySelectorAll('.pdp-media-item');
    for (var i = 0; i < items.length; i++) {
      if (items[i].getBoundingClientRect().height > THRESH) { return true; }
    }
    return false;
  }
  function fixBrokenGalleries() {
    if (!window.matchMedia || !window.matchMedia('(max-width:1023px)').matches) { return; }
    var grids = document.querySelectorAll('.pdp-image-grid');
    for (var i = 0; i < grids.length; i++) {
      var grid = grids[i];
      if (grid.classList.contains('clx-gallery-fallback')) { continue; }
      // Only intervene if the grid has media to show but none of it is visible.
      if (grid.querySelector('.pdp-media-item.is-visible') && !anyMediaShown(grid)) {
        grid.classList.add('clx-gallery-fallback');
      }
    }
  }
  function schedule() {
    // Delay the checks so a real (device-gated) carousel gets first chance to init.
    setTimeout(fixBrokenGalleries, 800);
    setTimeout(fixBrokenGalleries, 2000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  // Re-check if the viewport crosses into mobile after load (rotate / resize).
  window.addEventListener('orientationchange', function () { setTimeout(fixBrokenGalleries, 400); });
})();

  } catch(e) { console.error(e); }
})();
})();
